import { createActions, createReducer } from 'reduxsauce'
import Immutable, { type ImmutableObject } from 'seamless-immutable'

import type { AccountLinkingState } from 'APP/Store/AccountLinking/types'

/* ------------- Types and Action Creators ------------- */

const actionDefs = {
  requestAccountLinking: ['accountCreation'],
  resetAccountLinking: null,
  accountLinkingSuccess: null,
  accountLinkingFailure: ['error', 'errorType'],
} as const satisfies Record<string, string[] | null>

type TActions = typeof actionDefs
type TPayloads = {}

const { Types, Creators } = createActions<TPayloads, TActions>(actionDefs)

export const AccountLinkingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

type ImmutableAccountLinkingState = ImmutableObject<AccountLinkingState>

type AccountLinkingFailureAction = {
  error: string | null
  errorType: string | null
}

export const INITIAL_STATE: ImmutableAccountLinkingState = Immutable<AccountLinkingState>({
  running: false,
  error: null,
  errorType: null,
})

/* ------------- Reducers ------------- */

export const resetLinking = (state: ImmutableAccountLinkingState) => state.merge(INITIAL_STATE)

export const linkingRunning = (state: ImmutableAccountLinkingState) =>
  state.merge({ running: true, error: null, errorType: null })

export const linkingSuccess = (state: ImmutableAccountLinkingState) =>
  state.merge({ running: false, error: null, errorType: null })

export const linkingFailure = (
  state: ImmutableAccountLinkingState,
  { error, errorType }: AccountLinkingFailureAction
) => state.merge({ running: false, error, errorType })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer<TPayloads, TActions, ImmutableAccountLinkingState>(
  INITIAL_STATE,
  {
    // @ts-expect-error TODO: write payload model for action & add it to TPayloads
    [Types.REQUEST_ACCOUNT_LINKING]: linkingRunning,
    [Types.RESET_ACCOUNT_LINKING]: resetLinking,
    [Types.ACCOUNT_LINKING_SUCCESS]: linkingSuccess,
    // @ts-expect-error TODO: write payload model for action & add it to TPayloads
    [Types.ACCOUNT_LINKING_FAILURE]: linkingFailure,
  }
)
